import { render, staticRenderFns } from "./OpenBoard.vue?vue&type=template&id=3cabe2d0&scoped=true"
import script from "./OpenBoard.vue?vue&type=script&lang=js"
export * from "./OpenBoard.vue?vue&type=script&lang=js"
import style0 from "./OpenBoard.vue?vue&type=style&index=0&id=3cabe2d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cabe2d0",
  null
  
)

export default component.exports